import { createSelector } from 'reselect';
import { stickyNavBarPdpSelector } from 'selectors/testTarget/offers/stickyNavBarPdp/stickyNavBarPdpSelector';

const experienceSelector = createSelector(stickyNavBarPdpSelector, stickyNavBarPdp => stickyNavBarPdp.experience);

export { experienceSelector };
